import React, { FC, Fragment, useState } from "react";

import { Transition, Dialog } from "@headlessui/react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import useProfilePointHistory from "hooks/useProfilePointHistory";
import { useTranslation } from "react-i18next";
import Badge from "shared/Badge/Badge";

export default function ProfilePointHistory({ history }: any) {
  const { modifiedPointHistory, isShowModal, _onOpen, _onClose } = useProfilePointHistory(history);

  const { t } = useTranslation();

  const renderPointHistory = () => {
    return (
      <Transition appear show={isShowModal} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={_onClose}>
          <div className="min-h-screen px-4 text-center">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3 className="text-lg font-medium leading-6 text-gray-900" id="headlessui-dialog-title-70">
                      {t("profile_point_his_title")}
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={_onClose} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    <div className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8">
                      <span className="text-sm text-neutral-500" style={{ width: "10%" }}>
                        {t("profile_point_his_id")}
                      </span>
                      <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                        {t("profile_point_his_date")}
                      </span>
                      <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                        {t("profile_point_his_category")}
                      </span>
                      <span className="text-sm text-neutral-500" style={{ width: "10%" }}>
                        {t("profile_point_his_quality")}
                      </span>
                      <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                        {t("profile_point_his_remarks")}
                      </span>
                    </div>
                    {modifiedPointHistory?.map((item: any, index: number) => (
                      <div key={index} className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8">
                        <span className="text-sm text-neutral-500" style={{ width: "10%" }}>
                          # {item.point_id}
                        </span>
                        <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                          {item.date}
                        </span>
                        <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                          <i className={`text-xl text-neutral-500 las ${item.icon}`} style={{ marginRight: 10 }}></i>
                          {item.title}
                        </span>
                        <Badge color={item.color} name={item.value} />
                        <span className="text-sm text-neutral-500" style={{ width: "20%" }}>
                          {item.remarks}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  return (
    <>
      {renderPointHistory()}
      <ButtonSecondary onClick={_onOpen}>
        <i className="text-xl las la-history"></i>
        <span className="ml-3"> {t("profile_point_his_view_title")}</span>
      </ButtonSecondary>
    </>
  );
}
